import { useState } from "react";
import { Products } from "../Products";
import { useParams, useNavigate } from "react-router-dom";

const ProductDetail = () => {
  const [quantity, setQuantity] = useState(1);
  const { id } = useParams();
  const navigate = useNavigate();
  const product = Products.find((p) => p.id === Number(id));

  if (!product) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-[#000000] mb-4">Product Not Found</h2>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2 bg-[#EE645A] text-white font-medium rounded-full hover:bg-[#D84530] transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className='w-full px-4 sm:px-8 lg:px-[50px] py-5 sm:py-6 lg:py-[30px] bg-[#EE645A] font-poppins'>
        <div className="max-w-[1200px] mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white mb-3 hover:opacity-80 transition-opacity text-sm sm:text-base"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className='font-bold text-xl sm:text-2xl lg:text-[32px] text-white break-words'>
            {product.name}
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          
          {/* Left - Image Section */}
          <div className="flex items-start justify-center lg:sticky lg:top-20">
            <div className='bg-white rounded-lg sm:rounded-[16px] shadow-lg p-4 sm:p-6 lg:p-8 w-full h-fit'>
              <div className="bg-[#FFF8F6] rounded-lg sm:rounded-[12px] p-4 sm:p-6 lg:p-8 flex items-center justify-center aspect-square sm:aspect-auto sm:min-h-[300px] lg:min-h-[400px]">
                <img
                  src={product.img}
                  alt={product.name}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          {/* Right - Product Details */}
          <div className='space-y-6 sm:space-y-7 lg:space-y-8'>
            
            {/* Product Name */}
            <div>
              <h1 className='font-bold text-2xl sm:text-3xl lg:text-[40px] text-[#000000] leading-tight mb-3 sm:mb-4 break-words'>
                {product.name}
              </h1>
              
              {/* Price */}
              <div className='flex items-center gap-4 mb-4 sm:mb-6'>
                <p className='text-2xl sm:text-3xl lg:text-[36px] font-bold text-[#EE645A]'>
                  {product.price}
                </p>
              </div>

              {/* Rating/Status */}
              <div className='flex items-center gap-2 mb-4 sm:mb-6'>
                <span className='text-xs sm:text-sm bg-[#FFF8F6] text-[#EE645A] px-3 sm:px-4 py-1.5 rounded-full font-medium whitespace-nowrap'>
                  Handcrafted Product
                </span>
              </div>
            </div>

            {/* Description */}
            <div className='bg-white rounded-lg sm:rounded-[12px] p-4 sm:p-6 shadow-sm'>
              <h3 className='font-bold text-base sm:text-lg lg:text-[18px] text-[#000000] mb-2 sm:mb-3'>About This Product</h3>
              <p className='text-sm sm:text-base lg:text-[15px] text-[#666666] leading-relaxed'>
                {product.desc}
              </p>
            </div>

            {/* Quantity Selector */}
            <div className='space-y-3 sm:space-y-4'>
              <h3 className='font-bold text-base sm:text-lg lg:text-[18px] text-[#000000]'>Quantity</h3>
              <div className='flex items-center gap-3 sm:gap-4 flex-wrap'>
                <div className='flex items-center border-2 border-[#EEE] rounded-lg sm:rounded-[8px] bg-white'>
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className='w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-[#666666] hover:text-[#EE645A] hover:bg-[#FFF8F6] transition-colors font-bold text-lg sm:text-[20px]'
                  >
                    −
                  </button>
                  <span className='w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-base sm:text-[18px] font-bold text-[#000000] border-l-2 border-r-2 border-[#EEE]'>
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className='w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-[#666666] hover:text-[#EE645A] hover:bg-[#FFF8F6] transition-colors font-bold text-lg sm:text-[20px]'
                  >
                    +
                  </button>
                </div>
                <p className='text-xs sm:text-sm lg:text-[14px] text-[#666666]'>Available in stock</p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className='flex flex-col sm:flex-row gap-3 sm:gap-4'>
              <a
                href={`https://wa.me/7808056151?text=Hi! I'm interested in purchasing the following product:%0A%0A*Product Name:* ${encodeURIComponent(product.name)}%0A*Price:* ${encodeURIComponent(product.price)}%0A*Quantity:* ${quantity}%0A%0APlease provide more details about this product and confirm availability.`}
                target="_blank"
                rel="noopener noreferrer"
                className='flex-1 py-2.5 sm:py-3 bg-[#EE645A] text-white font-bold text-sm sm:text-base lg:text-[16px] rounded-lg sm:rounded-[8px] hover:bg-[#D84530] transition-colors text-center block'
              >
                Buy Now via WhatsApp
              </a>
              <button
                onClick={() => alert('Added to cart!')}
                className='flex-1 py-2.5 sm:py-3 border-2 border-[#EE645A] text-[#EE645A] font-bold text-sm sm:text-base lg:text-[16px] rounded-lg sm:rounded-[8px] hover:bg-[#FFF8F6] transition-colors'
              >
                Add to Cart
              </button>
            </div>

            {/* Divider */}
            <hr className='border-[#EEE]' />

            {/* Product Info */}
            <div className='bg-white rounded-lg sm:rounded-[12px] p-4 sm:p-6 shadow-sm space-y-4'>
              <div className='grid grid-cols-2 gap-4 sm:gap-6'>
                <div>
                  <p className='text-xs sm:text-sm text-[#999999] font-medium mb-1'>Category</p>
                  <p className='text-sm sm:text-base lg:text-[15px] text-[#333333] font-medium break-words'>Handcrafted Items</p>
                </div>
                <div>
                  <p className='text-xs sm:text-sm text-[#999999] font-medium mb-1'>Product ID</p>
                  <p className='text-sm sm:text-base lg:text-[15px] text-[#333333] font-medium break-words'>PROD{String(id).padStart(3, '0')}</p>
                </div>
              </div>

              {/* Shipping Info */}
              <div className='pt-4 border-t border-[#EEE]'>
                <div className='flex items-start gap-2 sm:gap-3 mb-3'>
                  <svg className='w-5 h-5 text-[#EE645A] flex-shrink-0 mt-0.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 10V3L4 14h7v7l9-11h-7z' />
                  </svg>
                  <div className='min-w-0'>
                    <p className='font-medium text-xs sm:text-sm lg:text-[14px] text-[#000000]'>Fast Shipping</p>
                    <p className='text-xs sm:text-sm lg:text-[13px] text-[#666666] break-words'>Delivered to your doorstep quickly</p>
                  </div>
                </div>
                <div className='flex items-start gap-2 sm:gap-3'>
                  <svg className='w-5 h-5 text-[#EE645A] flex-shrink-0 mt-0.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' />
                  </svg>
                  <div className='min-w-0'>
                    <p className='font-medium text-xs sm:text-sm lg:text-[14px] text-[#000000]'>Authentic & Verified</p>
                    <p className='text-xs sm:text-sm lg:text-[13px] text-[#666666] break-words'>100% authentic handcrafted products</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Share Section */}
            <div className='bg-white rounded-lg sm:rounded-[12px] p-4 sm:p-6 shadow-sm'>
              <p className='font-bold text-base sm:text-lg lg:text-[16px] text-[#000000] mb-3 sm:mb-4'>Share this product</p>
              <div className='flex gap-3 sm:gap-4'>
                <a href='https://www.facebook.com/' className='w-9 h-9 sm:w-10 sm:h-10 bg-[#FFF8F6] rounded-full flex items-center justify-center text-base sm:text-lg hover:bg-[#EE645A] hover:text-white transition-colors flex-shrink-0'>
                  f
                </a>
                <a href='https://x.com/' className='w-9 h-9 sm:w-10 sm:h-10 bg-[#FFF8F6] rounded-full flex items-center justify-center text-base sm:text-lg hover:bg-[#EE645A] hover:text-white transition-colors flex-shrink-0'>
                  𝕏
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products CTA */}
      {/* <div className='bg-white border-t border-[#EEE] mt-8 sm:mt-12 py-8 sm:py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-[1200px] mx-auto text-center'>
          <h2 className='text-xl sm:text-2xl lg:text-[32px] font-bold text-[#000000] mb-3 sm:mb-4 break-words'>
            Support Artisans
          </h2>
          <p className='text-sm sm:text-base lg:text-[15px] text-[#666666] mb-5 sm:mb-6 max-w-[700px] mx-auto leading-relaxed'>
            By purchasing this handcrafted product, you're directly supporting women artisans and underprivileged communities. Thank you for making a difference!
          </p>
          <a 
            href='/products'
            className='inline-block px-6 sm:px-8 py-2.5 sm:py-3 bg-[#EE645A] text-white font-bold text-sm sm:text-base rounded-lg sm:rounded-[8px] hover:bg-[#D84530] transition-colors'
          >
            Explore More Products
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default ProductDetail;